import classNames from "classnames/bind";
import Icon from "../../../../Foundation/Icons";
import { IconColours } from "../../../../Foundation/Icons/interface";
import { IconButtonProps } from "../../interface";
import classes from "./iconButton.module.scss";
import { forwardRef } from "react";

const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
    (
        {
            label,
            name,
            size = "24",
            variant,
            onClick,
            disabled = false,
            background = false,
            iconTitle = name,
        },
        ref
    ) => {
        const cx = classNames.bind(classes);
        const iconButtonClasses = cx(
            "iconButton",
            name,
            [variant],
            background ? "background" : null,
            disabled ? "disabled" : "enabled"
        );

        return (
            <button
                type="button"
                className={iconButtonClasses}
                onClick={onClick}
                aria-label={label}
                title={label}
                disabled={disabled}
                data-testid="icon-button"
                ref={ref}
            >
                <Icon
                    name={name}
                    colour={
                        variant === "dark"
                            ? IconColours.white
                            : IconColours.black
                    }
                    size={size}
                    ariaHidden={true}
                    title={iconTitle}
                ></Icon>
            </button>
        );
    }
);

export default IconButton;
